import React from "react";
import Header from "../components/generalComponents/Header";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import Basket from "../components/basket/Basket";

export default function BasketView() {
  return (
    <div className="pageWrapper">
      <Header title="Winkelmandje" needsLocation="Yes" />
      <div className="contentWrapper fadeInDelayed">
        <Basket />
      </div>
      <BottomNavBar />
    </div>
  );
}
